
function SupervisorScore() {
    return(
        <>
        Score
        </>
    )
}

export default SupervisorScore;